export const YOUNGEST_AGE_ON_PLATFORM = 13;

export const YOUNGEST_AGE_FOR_HEALTH_AND_PROMO = 16;

export const GENDER = Object.freeze({
  man: 'man',
  woman: 'woman',
  preferNotSay: 'prefer_not_say',
  nonBinary: 'nonbinary'
});
export type GenderType = (typeof GENDER)[keyof typeof GENDER];

export const LOCALE = Object.freeze({
  deDE: 'de-DE',
  enUS: 'en-US',
  enGB: 'en-GB',
  esES: 'es-ES',
  es419: 'es-419',
  frFR: 'fr-FR',
  itIT: 'it-IT',
  jaJP: 'ja-JP',
  nlNL: 'nl-NL',
  ptBR: 'pt-BR',
  ptPT: 'pt-PT',
  ruRU: 'ru-RU',
  zhCN: 'zh-CN',
  zhTW: 'zh-TW'
});
export type LocaleType = (typeof LOCALE)[keyof typeof LOCALE];

// If a language has more than one locale, the first in the list is the default
export const LANGUAGE_LOCALES = Object.freeze({
  de: [LOCALE.deDE],
  // en is intentionally omitted here since English is the global default
  es: [LOCALE.esES, LOCALE.es419],
  fr: [LOCALE.frFR],
  it: [LOCALE.itIT],
  ja: [LOCALE.jaJP],
  nl: [LOCALE.nlNL],
  pt: [LOCALE.ptPT, LOCALE.ptBR],
  ru: [LOCALE.ruRU],
  zh: [LOCALE.zhCN, LOCALE.zhTW]
});
export type LanguageLocaleType =
  (typeof LANGUAGE_LOCALES)[keyof typeof LANGUAGE_LOCALES];

export const EXPERIMENT_TARGETS = Object.freeze({
  all: 'all',
  android: 'android',
  desktop: 'desktop',
  iphone: 'iphone',
  mobile: 'mobile'
});

export type ExperimentTargetType =
  (typeof EXPERIMENT_TARGETS)[keyof typeof EXPERIMENT_TARGETS];

export const EXPERIMENT_COHORTS = Object.freeze({
  control: 'control',
  variantA: 'variant-a',
  variantB: 'variant-b',
  variantC: 'variant-c',
  variantD: 'variant-d'
});
export type ExperimentCohortType =
  (typeof EXPERIMENT_COHORTS)[keyof typeof EXPERIMENT_COHORTS];

export const MOBILE_OS = Object.freeze({
  android: 'android',
  iPhone: 'iphone',
  iPad: 'ipad'
});
export type MobileOSType = (typeof MOBILE_OS)[keyof typeof MOBILE_OS];

export const SUPPORTED_BROWSERS = Object.freeze({
  chrome: 'chrome',
  firefox: 'firefox',
  safari: 'safari'
});
export type SupportedBrowserType =
  (typeof SUPPORTED_BROWSERS)[keyof typeof SUPPORTED_BROWSERS];

// universal link paths from 'apple-app-site-association' file in active
export const APPLE_APP_LINK_PATHS = [
  '/dashboard',
  '/activities/*',
  '/athletes/*',
  '/segments/*',
  '/challenges/*',
  '/videos/*',
  '/routes/*',
  '/premium/*',
  '/settings/*',
  '/shop/*',
  '/athlete/*',
  '/clubs/*',
  '/summit/join',
  '/summit/perks',
  '/oauth/mobile/authorize'
];

export const ATHLETES_VISIBILITY = Object.freeze({
  optedOut: 'opted_out' // Strava::Athletes::Visibility::OPTED_OUT
});
export type AthletesVisibilityType =
  (typeof ATHLETES_VISIBILITY)[keyof typeof ATHLETES_VISIBILITY];
